var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{attrs:{"flat":"","tile":""}},[_c('v-card-text',[_c('video',{staticStyle:{"width":"100%","max-width":"450px"},attrs:{"id":"video-preview","src":_vm.dataUrl,"controls":""}})])],1)}
var staticRenderFns = []

export { render, staticRenderFns }